module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "sylvester-walch.543aabb4.jpg" + "?" + Date.now();